// extracted by mini-css-extract-plugin
export default {"blocContainer":"REFv9EdXx1seJqs0nI3K","titleContainer":"j2zvMllieIbQXyXakxEK","wysiwygEditorContainer":"rNRfofzjLW1bnYMHh5P8","whiteColor":"c6448H0gy7cBbAWVteNF"};